import { useStyleSheet } from '../../../../../../hooks/useStyleSheet';

export const useStyles = () => {
  const styles = useStyleSheet(
    (theme) => ({
      root: {
        color: theme.palette.secondary.dark,
        display: 'flex',
        justifyContent: 'space-between',
        background: 'transparent',
        border: 'none',
        outline: 'none',
        width: '100%',
        cursor: 'pointer',
      },
      icon: {
        marginLeft: theme.spacing.secondary,
      },
    }),
    [],
  );

  return styles;
};
